declare module 'modifyjs';
